
    import './styles.scoped.css';
    export default {
  "options-list": "_options-list_wbb26_3",
  "decrease-top-margin": "_decrease-top-margin_wbb26_21"
};
  